var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogueEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.574 140.735V87.5947C223.574 75.8725 218.573 71.1836 206.147 71.1836H174.575C162.15 71.1836 157.148 75.8725 157.148 87.5947V140.735C157.148 152.458 162.15 157.147 174.575 157.147H206.147C218.573 157.147 223.574 152.458 223.574 140.735Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.52 157.931V211.071C141.52 222.794 136.518 227.482 124.093 227.482H92.5208C80.0952 227.482 75.0938 222.794 75.0938 211.071V157.931C75.0938 146.208 80.0952 141.52 92.5208 141.52H124.093C136.518 141.52 141.52 146.208 141.52 157.931Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M223.574 211.07V189.188C223.574 177.466 218.573 172.777 206.147 172.777H174.575C162.15 172.777 157.148 177.466 157.148 189.188V211.07C157.148 222.792 162.15 227.481 174.575 227.481H206.147C218.573 227.481 223.574 222.792 223.574 211.07Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.52 109.476V87.5947C141.52 75.8725 136.518 71.1836 124.093 71.1836H92.5208C80.0952 71.1836 75.0938 75.8725 75.0938 87.5947V109.476C75.0938 121.198 80.0952 125.887 92.5208 125.887H124.093C136.518 125.887 141.52 121.198 141.52 109.476Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogueEmpty);
export default __webpack_public_path__ + "static/media/catalogueEmpty.29573bdc7af68b9f9f089d7cbffe4646.svg";
export { ForwardRef as ReactComponent };